// Header Background svg
export default function HeaderBg() {
  return (
    <div className="absolute top-0 right-0 w-screen h-screen -z-50 *:size-full *:object-cover">
      <img src="/images/header/header__bg.svg" alt="Header background img" />
    </div>
  );
}
